import { Provider } from '@angular/core';
import {
  DownloadStowageComplianceReportUseCase,
  GetListStowageComplianceReportUseCase,
  GetShiftObservationReportUrlUseCase,
} from '@app/application/use-cases';
import { ReportRepository } from '@app/domain';
import { ReportRepositoryImpl } from '../repositories';

export const REPORT_PROVIDER: Provider[] = [
  //Repositories
  {
    provide: ReportRepository,
    useClass: ReportRepositoryImpl,
  },
  {
    provide: GetShiftObservationReportUrlUseCase,
    useFactory: (reportRepo: ReportRepository) =>
      new GetShiftObservationReportUrlUseCase(reportRepo),
    deps: [ReportRepository],
  },
  {
    provide: GetListStowageComplianceReportUseCase,
    useFactory: (reportRepo: ReportRepository) =>
      new GetListStowageComplianceReportUseCase(reportRepo),
    deps: [ReportRepository],
  },
  {
    provide: DownloadStowageComplianceReportUseCase,
    useFactory: (reportRepo: ReportRepository) =>
      new DownloadStowageComplianceReportUseCase(reportRepo),
    deps: [ReportRepository],
  },
];
